module.exports = __webpack_public_path__ + "static/media/login-logo.1caf1601.png";